<script setup lang="ts">
import { computed } from "vue";

import Button from "~/components/dumb/Button.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { CollapseIcon, DownloadIcon, ExpandIcon, FullscreenIcon, TrashIcon } from "~/icons";
import { ButtonSize, ButtonStyle, IconSize } from "~/shared/enums";

const props = defineProps<{
  showFullscreen?: boolean;
  showDownload?: boolean;
  showCollapseExpand?: boolean;
  showDelete?: boolean;
  collapseExpandText: string;
  collapseExpandIcon?: "collapse" | "expand";
  opaqueBackground?: boolean;
  opaqueButtonHover?: boolean;
  staticPosition?: boolean;
}>();

const emit = defineEmits<{
  fullscreen: [];
  download: [];
  collapseExpand: [];
  delete: [];
}>();

const collapseExpandIconComponent = computed(() => (props.collapseExpandIcon === "expand" ? ExpandIcon : CollapseIcon));
const buttonClass = computed(() => (props.opaqueButtonHover ? "!p-1 hover:bg-hvy" : "!p-1 hover:bg-hvy/80"));
const showDownloadAction = computed(() => props.showDownload !== false);
</script>

<template>
  <div
    class="!pointer-events-auto flex items-center rounded-sm text-md"
    :class="[staticPosition ? '' : 'absolute', opaqueBackground ? 'bg-md' : 'bg-md/80']">
    <Tooltip v-if="showFullscreen" text="Fullscreen">
      <Button
        :class="buttonClass"
        :btn-style="ButtonStyle.CHIP"
        :icon="FullscreenIcon"
        borderless
        :icon-size="IconSize.XS"
        a11y-label="Fullscreen"
        @click.stop="emit('fullscreen')" />
    </Tooltip>
    <Tooltip v-if="showDownloadAction" text="Download">
      <Button
        :class="buttonClass"
        :btn-style="ButtonStyle.CHIP"
        :icon="DownloadIcon"
        borderless
        :icon-size="IconSize.XS"
        a11y-label="Download"
        @click.stop="emit('download')" />
    </Tooltip>
    <Tooltip v-if="showCollapseExpand" :text="collapseExpandText">
      <Button
        :class="buttonClass"
        :btn-style="ButtonStyle.CHIP"
        :icon="collapseExpandIconComponent"
        borderless
        :icon-size="IconSize.XS"
        :a11y-label="collapseExpandText"
        @click.stop="emit('collapseExpand')" />
    </Tooltip>
    <Tooltip v-if="showDelete" text="Delete">
      <Button
        :class="buttonClass"
        :btn-style="ButtonStyle.CHIP"
        :size="ButtonSize.CHIP"
        :icon="TrashIcon"
        borderless
        :icon-size="IconSize.XS"
        a11y-label="Delete"
        @click.stop="emit('delete')" />
    </Tooltip>
  </div>
</template>
